import React, { createContext, useState, useEffect, useCallback } from 'react';
export const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
    let initialSessionId = null;
    let initialIsSessionReady = false;
    try {
        initialSessionId = sessionStorage.getItem('session_id');
        initialIsSessionReady = !!initialSessionId;
    } catch (e) {
        console.error('SessionContext: Unable to access sessionStorage:', e);
    }
    const [sessionId, setSessionId] = useState(initialSessionId);
    const [isSessionReady, setIsSessionReady] = useState(initialIsSessionReady);

    // Function to update session state from sessionStorage
    const updateSessionFromStorage = useCallback(() => {
        let currentSessionId = null;
        try {
            currentSessionId = sessionStorage.getItem('session_id');
        } catch (e) {
            console.error('SessionContext: Unable to access sessionStorage during update:', e);
            currentSessionId = null;
        }
        if (currentSessionId !== sessionId) {
            setSessionId(currentSessionId);
            setIsSessionReady(!!currentSessionId);
        }
    }, [sessionId]);

    // Listen for session changes in sessionStorage
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'session_id') {
                updateSessionFromStorage();
            }
        };

        // Listen for storage events from other tabs
        window.addEventListener('storage', handleStorageChange);
        // Set up a polling mechanism to catch changes within the same tab
        const POLL_INTERVAL_MS = 2000; // Configurable interval (default 2 seconds)
        const pollInterval = setInterval(updateSessionFromStorage, POLL_INTERVAL_MS);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            clearInterval(pollInterval);
        };
    }, [updateSessionFromStorage]);

    // Custom method to manually refresh session state
    const refreshSession = useCallback(() => {
        updateSessionFromStorage();
    }, [updateSessionFromStorage]);

    return (
        <SessionContext.Provider value={{
            sessionId,
            setSessionId,
            isSessionReady,
            refreshSession
        }}>
        {children}
        </SessionContext.Provider>
    )
}
export default SessionContext;